module.exports = __webpack_public_path__ + "static/media/LK.82c9f72b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/LK.svg
// module id = 300
// module chunks = 0